import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call, select } from 'redux-saga/effects';
import { userFetch } from 'store/features/userFetch';
import { ApiStateData, Company, CompanyMetadata, MakerSelectors, UserData } from 'types';
type Data = Company;

type Payload = {
  companyId?: string;
};

interface ExtraSelectors extends MakerSelectors<ApiStateData<Data>> {
  getMetadata: (d: ApiStateData<Data>) => CompanyMetadata | undefined;
}

export const companyFetch = createApiSlice<Data, Payload | undefined, ExtraSelectors>({
  name: 'companyFetch',
  *tryGenerator(_, { payload }) {
    const userData: UserData = yield select(userFetch.selectors.getData);

    const companyId = payload?.companyId || userData?.companyId;

    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/auth/company/:companyId', urlParams: { companyId } }),
    });

    return data;
  },
  extraSelectors: {
    getMetadata: (data) => data?.metadata,
  },
});
